export interface FsLprRawFleetReadVehicleAttribute {
  color: {
    value: string;
    confidenceScore: number;
  };
  make: {
    value: string;
    confidenceScore: number;
  };
  type: {
    value: string;
    confidenceScore: number;
  };
  topRack?: {
    value: boolean;
    confidenceScore: number;
  };
  backRack?: {
    value: boolean;
    confidenceScore: number;
  };
  bumperStickers?: {
    value: boolean;
    confidenceScore: number;
  };
  windowStickers?: {
    value: boolean;
    confidenceScore: number;
  };
  boundingBox?: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
}
